import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.string.trim.js";
import { defineComponent as _defineComponent } from 'vue';
import { renderMarkdown } from '~/functions/markdown';
import { roundValue } from '~/functions/ghg';
export default /*#__PURE__*/_defineComponent({
  __name: 'AssumptionsAndLimitations',
  props: {
    impactSolution: null,
    sections: {
      default: undefined
    },
    hideSectionHeadings: {
      type: Boolean,
      default: false
    }
  },
  setup: function setup(__props) {
    var props = __props;
    var _ref = getCurrentInstance(),
      proxy = _ref.proxy;
    var showEmissions = computed(function () {
      var _props$sections;
      return !((_props$sections = props.sections) !== null && _props$sections !== void 0 && _props$sections.length) || props.sections.includes('emissions');
    });
    var showLimitations = computed(function () {
      var _props$sections2;
      return !((_props$sections2 = props.sections) !== null && _props$sections2 !== void 0 && _props$sections2.length) || props.sections.includes('limitations');
    });
    var ghgSavingPotential = computed(function () {
      var _props$impactSolution;
      return (_props$impactSolution = props.impactSolution) === null || _props$impactSolution === void 0 ? void 0 : _props$impactSolution.ghgSavingPotential;
    });
    var baselineGhgDisplay = computed(function () {
      return roundValue(ghgSavingPotential.value && ghgSavingPotential.value.preComputedBaselineGhg != null ? ghgSavingPotential.value.preComputedBaselineGhg : 0);
    });
    var solutionGhgDisplay = computed(function () {
      return roundValue(ghgSavingPotential.value && ghgSavingPotential.value.preComputedSolutionGhg != null ? ghgSavingPotential.value.preComputedSolutionGhg : 0);
    });
    var limitationsRaw = computed(function () {
      var _ghgSavingPotential$v, _ghgSavingPotential$v2;
      return (_ghgSavingPotential$v = (_ghgSavingPotential$v2 = ghgSavingPotential.value) === null || _ghgSavingPotential$v2 === void 0 ? void 0 : _ghgSavingPotential$v2.emissionSourceLimitations) !== null && _ghgSavingPotential$v !== void 0 ? _ghgSavingPotential$v : '';
    });
    var scenarioBCommentsRaw = computed(function () {
      var _ghgSavingPotential$v3, _ghgSavingPotential$v4;
      return (_ghgSavingPotential$v3 = (_ghgSavingPotential$v4 = ghgSavingPotential.value) === null || _ghgSavingPotential$v4 === void 0 ? void 0 : _ghgSavingPotential$v4.scenarioBComments) !== null && _ghgSavingPotential$v3 !== void 0 ? _ghgSavingPotential$v3 : '';
    });
    var hasScenarioBComments = computed(function () {
      return hasMeaningfulText(scenarioBCommentsRaw.value);
    });
    var scenarioBCommentsHtml = computed(function () {
      return renderMarkdown(hasScenarioBComments.value ? scenarioBCommentsRaw.value : '');
    });
    function hasMeaningfulText(value) {
      if (!value) return false;
      var stripped = value.replace(/<[^>]*>/g, '').trim();
      return stripped.length > 0 && stripped.toLowerCase() !== 'n/a';
    }
    var hasLimitationsContent = computed(function () {
      return hasMeaningfulText(limitationsRaw.value);
    });
    var limitationsHtml = computed(function () {
      return renderMarkdown(hasLimitationsContent.value ? limitationsRaw.value : '');
    });
    var isScenarioA = computed(function () {
      var _ghgSavingPotential$v5, _ghgSavingPotential$v6;
      return (_ghgSavingPotential$v5 = (_ghgSavingPotential$v6 = ghgSavingPotential.value) === null || _ghgSavingPotential$v6 === void 0 ? void 0 : _ghgSavingPotential$v6.isScenarioA) !== null && _ghgSavingPotential$v5 !== void 0 ? _ghgSavingPotential$v5 : true;
    });
    var emissionSources = computed(function () {
      var _ghgSavingPotential$v7, _ghgSavingPotential$v8;
      return (_ghgSavingPotential$v7 = (_ghgSavingPotential$v8 = ghgSavingPotential.value) === null || _ghgSavingPotential$v8 === void 0 ? void 0 : _ghgSavingPotential$v8.emissionSources) !== null && _ghgSavingPotential$v7 !== void 0 ? _ghgSavingPotential$v7 : [];
    });
    var scenarioAHeaders = computed(function () {
      return [{
        text: proxy.$t('table.compare'),
        value: 'sourceOfEmission',
        width: '150px',
        sortable: false
      }, {
        text: proxy.$t('table.baseline'),
        value: 'baseline',
        width: '250px',
        sortable: false
      }, {
        text: proxy.$t('table.solution'),
        value: 'solution',
        width: '250px',
        sortable: false
      }];
    });
    var scenarioAItems = computed(function () {
      return emissionSources.value;
    });
    var nonScenarioAHeaders = computed(function () {
      return [{
        text: proxy.$t('table.compare'),
        value: 'overallGhg',
        width: '150px',
        sortable: false
      }, {
        text: proxy.$t('table.baseline'),
        value: 'baseline',
        width: '250px',
        sortable: false
      }, {
        text: proxy.$t('table.solution'),
        value: 'solution',
        width: '250px',
        sortable: false
      }];
    });
    var nonScenarioAItems = computed(function () {
      return [{
        overallGhg: proxy.$t('table.overallGhg')
      }];
    });
    return {
      __sfc: true,
      proxy: proxy,
      props: props,
      showEmissions: showEmissions,
      showLimitations: showLimitations,
      ghgSavingPotential: ghgSavingPotential,
      baselineGhgDisplay: baselineGhgDisplay,
      solutionGhgDisplay: solutionGhgDisplay,
      limitationsRaw: limitationsRaw,
      scenarioBCommentsRaw: scenarioBCommentsRaw,
      hasScenarioBComments: hasScenarioBComments,
      scenarioBCommentsHtml: scenarioBCommentsHtml,
      hasMeaningfulText: hasMeaningfulText,
      hasLimitationsContent: hasLimitationsContent,
      limitationsHtml: limitationsHtml,
      isScenarioA: isScenarioA,
      emissionSources: emissionSources,
      scenarioAHeaders: scenarioAHeaders,
      scenarioAItems: scenarioAItems,
      nonScenarioAHeaders: nonScenarioAHeaders,
      nonScenarioAItems: nonScenarioAItems,
      roundValue: roundValue
    };
  }
});